/* ================================================
   wash-care-block.js  →  assets/
   Accordion toggle — no dependencies
   ================================================ */
(function () {
  'use strict';

  function init(scope) {
    (scope || document).querySelectorAll('.wcb').forEach(function (el) {
      if (el._wcbReady) return;
      el._wcbReady = true;

      var btn     = el.querySelector('.wcb__trigger');
      var body    = el.querySelector('.wcb__body');
      if (!btn || !body) return;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        body.setAttribute('aria-hidden', open ? 'true' : 'false');
      });
    });
  }

  /* Initial load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Shopify theme editor */
  document.addEventListener('shopify:section:load', function () { init(); });

  /* Quick-view / drawer — watch for new DOM nodes */
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) init(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();